export default __webpack_public_path__ + "static/jonas-3bf6e7641bd8cd6c2705bc085690df62.png";